import React from 'react';
import { MapPin } from 'lucide-react';

const BADGE_STYLE = {
  'PEB Structure': 'text-[#C41E3A] border-[#C41E3A]/40',
  'Food Grade': 'text-green-400 border-green-400/40',
  'Agro Processing': 'text-green-400 border-green-400/40',
  'Largest Project': 'text-yellow-400 border-yellow-400/40',
  'Warehouse Complex': 'text-blue-400 border-blue-400/40',
};

const defaultBadge = 'text-[#9CA3AF] border-[#4A4A4A]';

export const ProjectCard = ({ project, onClick, heightClass = 'aspect-[4/3]' }) => {
  const { id, name, location, area, thumbImg, badge, category } = project;
  const badgeStyle = BADGE_STYLE[badge] || defaultBadge;

  return (
    <div
      className="relative group overflow-hidden cursor-pointer bg-[#0A0A0A]"
      onClick={() => onClick(project)}
      data-testid={`project-card-${id}`}
    >
      <div className={`${heightClass} overflow-hidden`}>
        <img
          src={thumbImg}
          alt={name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale-[25%] group-hover:grayscale-0"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/20 to-transparent" />
        {/* Top accent */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-[#C41E3A] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />
      </div>

      {/* Badge */}
      <span className={`absolute top-3 right-3 text-[9px] font-heading tracking-widest px-2 py-0.5 border ${badgeStyle} bg-black/70`}>
        {badge}
      </span>
      <span className="absolute top-3 left-3 text-[9px] font-body text-[#6B7280] tracking-widest bg-black/60 px-1.5 py-0.5">
        {category}
      </span>

      {/* Info */}
      <div className="absolute bottom-0 left-0 right-0 p-4">
        <div className="flex items-center gap-1.5 mb-1">
          <MapPin size={9} strokeWidth={1.5} className="text-[#C41E3A] shrink-0" />
          <span className="text-[#9CA3AF] text-[10px] font-body truncate">{location}</span>
        </div>
        <h3 className="font-heading text-sm text-white leading-tight">{name}</h3>
        <p className="text-[#C41E3A] text-[10px] font-body mt-0.5">{area}</p>
      </div>
    </div>
  );
};
